import { Directive, ElementRef, Renderer2, input } from '@angular/core';
import { ADPResourceService } from 'digital-core';

@Directive({
    selector: '[sf-aria-label]',
    standalone: true,
})
export class AriaLabelDirective {
  constructor(
    public elementRef: ElementRef,
    public renderer: Renderer2,
    public resourceService: ADPResourceService
  ) {}
  readonly label = input<string>(undefined, { alias: "sf-aria-label" });

  ngOnInit() {
    let resourceKey = this.label();

    if (resourceKey) {
      const ariaLabel = this.resourceService.getPortalLabel(resourceKey)?.Value ?? '';
      this.elementRef.nativeElement.setAttribute('aria-label', ariaLabel);
      // set timeout was used so that aria label is retained and not removed by any directives
      setTimeout(() => {
        this.elementRef.nativeElement.setAttribute('aria-label', ariaLabel);
      }, 500);
    }
  }
}
